import type {FormController} from '../internal/forms/types';
import {map} from 'rxjs/operators';
import {combineLatest} from 'rxjs';
import {createErrorMessagesId} from './utils';

export function ariaErrormessage(node: HTMLElement, formController: FormController<unknown>) {
    const subscription = combineLatest([formController.getFieldState$(), formController.isTouched$()])
        .pipe(map(([state, isTouched]) => [state.invalid, isTouched]))
        .subscribe(([isInvalid, isTouched]) => {
            if (isTouched && isInvalid) {
                node.setAttribute('aria-errormessage', createErrorMessagesId({editorId: formController.id, editorName: formController.name}));
            } else {
                node.removeAttribute('aria-errormessage');
            }
        });

    return {
        destroy: () => subscription.unsubscribe()
    };
}